import queryString from 'query-string'

export default (data) => new URLSearchParams(queryString.stringify(data, { arrayFormat: 'index' }))
